module.exports = __webpack_public_path__ + "img/xinzhuang-2.24ed61d1.jpg";